module.exports = require('react/lib/ReactComponentWithPureRenderMixin');


//////////////////
// WEBPACK FOOTER
// ./~/react-addons-pure-render-mixin/index.js
// module id = 95
// module chunks = 0